import {useMemo} from 'react';
import {requestContext} from '../../../../common/requestContext';
import {ContentHomeUpperTabItemType} from '../../../../design-system/organisms/ContentHomeUpperTab/ContentHomeUpperTabItemType.interface';
import {SaleMethod} from '../../../../graphql/generated/types';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {useContentHomeOverviewQuery} from '../../../../wrapper/contentWrapper';
import {
  CONTENT_HOME_MOBILE_TAB_LIST,
  CONTENT_HOME_PC_TAB_LIST,
  TAB_TYPE_QUERY_KEY,
} from '../constant';
import {ContentHomeTabType} from '../type';
import {getShouldShowPreviewTab} from '../util/getShouldShowPreviewTab';
import {useContentHomeLastNotice} from './useContentHomeLastNotice';
import {useContentHomeLastProductList} from './useContentHomeLastProductList';

export function useContentHomeTabList({
  seriesId,
}: {
  seriesId: number;
}): ContentHomeUpperTabItemType[] {
  const data = useContentHomeOverviewQuery({seriesId}, ONLY_DATA_CONFIG).data
    ?.contentHomeOverview;
  const {preview, pageContinue} = data?.content?.serviceProperty || {};
  const isCashTypeHome = data?.content?.saleMethod === SaleMethod.Cash;

  const {isUpdated: isNoticeUpdated} = useContentHomeLastNotice(seriesId);
  const {isUpdated: isProductListUpdated} =
    useContentHomeLastProductList(seriesId);
  const {isMobile} = requestContext.requestInfo.display;

  const tabList: ContentHomeUpperTabItemType[] = useMemo(() => {
    const contentTabList: ContentHomeUpperTabItemType[] = (
      isMobile
        ? isCashTypeHome
          ? CONTENT_HOME_MOBILE_TAB_LIST.slice(1)
          : CONTENT_HOME_MOBILE_TAB_LIST
        : CONTENT_HOME_PC_TAB_LIST
    )
      .map(tabItem => ({
        ...tabItem,
        href: `/content/${seriesId}?${TAB_TYPE_QUERY_KEY}=${tabItem.id}`,
      }))
      .filter(
        tabItem =>
          !tabItem.isPreview ||
          getShouldShowPreviewTab({isMobile, preview, pageContinue})
      );
    const noticeTabIndex = contentTabList.findIndex(
      tab => tab.id === ContentHomeTabType.notice
    );
    const productListTabIndex = contentTabList.findIndex(
      tab => tab.id === ContentHomeTabType.product
    );
    if (
      noticeTabIndex >= 0 &&
      contentTabList[noticeTabIndex].hasNewIcon !== isNoticeUpdated
    ) {
      contentTabList[noticeTabIndex] = {
        ...contentTabList[noticeTabIndex],
        hasNewIcon: isNoticeUpdated,
      };
    }
    if (
      productListTabIndex >= 0 &&
      contentTabList[productListTabIndex].hasNewIcon !== isProductListUpdated
    ) {
      contentTabList[productListTabIndex] = {
        ...contentTabList[productListTabIndex],
        hasNewIcon: isProductListUpdated,
      };
    }
    return contentTabList;
  }, [
    isMobile,
    isNoticeUpdated,
    isProductListUpdated,
    pageContinue,
    preview,
    seriesId,
    isCashTypeHome,
  ]);

  return tabList;
}
